module.exports = __webpack_public_path__ + "8dc3da1d606225ee632a97ac61aa6395.svg";